// Module
var code = "<div class=\"input-group daterange-picker\"> <button [disabled]=\"disabled\" type=\"button\" class=\"btn btn-default d-flex align-items-center\" #daterange> <i class=\"fa fa-calendar m-1\"></i> <span style=\"white-space:nowrap\" [custom-label]=\"label\"></span> <i class=\"fa fa-caret-down m-1\"></i> </button> </div>";
// Exports
module.exports = code;